var _ellipse, _path, _ellipse2, _ellipse3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeSbg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 315,
    viewBox: "0 0 321 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.5,
    cy: 161.105,
    rx: 154.5,
    ry: 153.105,
    fill: "#2667B0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 0.5C239.556 0.5 308.5 68.8281 308.5 153.105C308.5 237.383 239.556 305.711 154.5 305.711C69.4439 305.711 0.500067 237.383 0.5 153.105C0.5 68.8281 69.4439 0.5 154.5 0.5Z",
    stroke: "#2667B0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5,
    cy: 42.3056,
    rx: 12.5,
    ry: 12.3872,
    fill: "#FF7F50"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5,
    cy: 24.4684,
    rx: 3.5,
    ry: 3.46841,
    fill: "#FF7F50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeSbg);
export default __webpack_public_path__ + "static/media/MESbg.c1e79839406244fc941f92d50acda3cd.svg";
export { ForwardRef as ReactComponent };